import moment from "moment";

export const dateFormatter = (date: moment.MomentInput) => {
  return moment(date).format("ll");
};

export const timeFormatter = (date: moment.MomentInput) => {
  return moment(date).format("LT");
};
